import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, getCurrentInstance } from "vue";
import { useCommerceDebutGuideStore } from "@/stores/commerceDebutGuide";
import AgentIntro from "@/components/organisms/AgentIntro.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommerceDebutGuide',
  setup(__props) {

const instance = getCurrentInstance();

const commerceDebutGuideStore = useCommerceDebutGuideStore();

const iframeSrc = computed(() => {
  switch (commerceDebutGuideStore.selectedMenu) {
    case "menu1":
      return `${process.env.VUE_APP_NOLA_WEB}/path-to-commerce?utm_source=path-to-commerce&utm_medium=webtop&utm_campaign=path-to-commerce_guide_web`;
    case "menu3":
      return `${process.env.VUE_APP_NOLANOVEL_WEB}/about?utm_source=nolanovel-about&utm_medium=webtop&utm_campaign=nolanovel-about_guide_web`;
    default:
      return "";
  }
});

const handleMessage = (event: MessageEvent) => {
  const { type, page } = event.data;

  if (type === "navigate" && page === "agent") {
    // 商業道LPからの遷移の場合、エージェント画面へ遷移
    instance?.proxy.$router.push("/agent");
  }
};

onMounted(() => {
  // 初期表示は「Nolaで商業化を目指すコツを読む」
  commerceDebutGuideStore.setSelectedMenu("menu1");

  window.addEventListener("message", handleMessage);
});

return { __sfc: true,instance, commerceDebutGuideStore, iframeSrc, handleMessage, AgentIntro }
}

})